import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { ILoopProps } from './index';
import { ComponentConfigType } from '../../utils/data-parser';

export const generate = (
  props?: Partial<IComponentSchema<ILoopProps>>
): IComponentSchema<ILoopProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Loop',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.Loop,
    'x-component-props': {
      items: [],
      transformer: undefined,
      visible: true,
      itemName: 'item',
    },
    'x-component-props-config': {
      items: {
        type: ComponentConfigType.Variable,
      },
    },
  };
};
